<template>
  <div class="secondMap" style="position: relative;width: 100%; height:100%">
    <div
      ref="mapRef"
      id="map-container"
      style="width: 100%; height: 100%"
    ></div>
    <div id="overflow">
      <div
        class="btn"
        v-if="showType == 'AirPoint' && canDraw && !checkedPoint"
        @click="choosePoint"
      >
        <span>选择航点</span>
      </div>
      <div
        class="btn"
        v-if="showType == 'AirPoint' && canDraw && checkedPoint"
        @click="cancelPoint"
      >
        <span>取消航点</span>
      </div>
      <div
        class="btn"
        v-if="showType == 'AirLine' && canDraw && !checkedLine"
        style="display:block"
        @click="chooseLine"
      >
        <span>手绘航线</span>
      </div>
      <div
        class="btn"
        v-if="showType == 'AirLine' && canDraw && checkedLine"
        @click="cancelLine"
      >
        <span>取消航线</span>
      </div>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import {
  wgs84ToGcj02,
  gcj02ToWgs84
} from "../../src/assets/js/map/ConverseLngAndLa";
export default {
  props: {
    //父组件传递的数据
    //绘制类型（航点、航线、航迹）
    showType: {
      type: String,
      default: ""
    },
    //是否可绘制
    canDraw: {
      type: Boolean,
      default: false
    },
    //弹窗开关
    resetLineMap: {
      type: Boolean,
      default: false
    },
    //航点数据
    airPoint: {
      type: Array,
      default: () => []
    },
    //航线数据
    airpointList: {
      type: Array,
      default: () => []
    }
  },
  name: "secondMap",
  data() {
    return {
      map: null,
      // center: [32.06, 118.8],//南京
      // center: [24.9402, 118.1806],//南安
      // center: [25.20249487751626, 118.44143629074098],//南安九都镇
      center: [31.2995549, 121.4511],//上海市静安区
      checkedPoint: false, //选择取消航点
      checkedLine: false, //选择取消航线
      markerPoint: null, //绘制的航点
      positionLine: null, //航迹或者航道的线
      drawControl: null, //空域选择类型控件
      drawnItems: null
    };
  },
  mounted() {
    window.addEventListener("message", e => {
      if (e.data == "clearPlane") {
        if (this.positionLine) {
          this.map.removeLayer(this.positionLine);
        }
      }
    });
    this.initMap();
  },
  methods: {
    initMap() {
      // 初始化地图
      var layer = L.tileLayer(
        // "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}"
         "https://wprd01.is.autonavi.com/appmaptile?langzh_cn&size=1&scale=1&style=8{ltype}&x={x}&y={y}&z={z}", {
            ltype: "11"}
      );
      //创建地图
      var map = L.map("map-container", {
        center: this.center, //中心坐标
        zoom: 10, //缩放级别
        minZoom: 3,
        maxZoom: 18,
        zoomControl: false, //缩放组件
        attributionControl: false, //去掉右下角logol
        layers: [layer] //图层
      });
      this.map = map;
      // 初始化Leaflet.draw控件
      var drawnItems = new L.FeatureGroup();
      this.map.addLayer(drawnItems);
      // 绘制控件初始化代码...
      this.drawControl = new L.Control.Draw({
        draw: {
          marker: {
            icon: L.icon({
              iconUrl: "../../static/blueMarker.png",
              iconSize: [30, 30]
              // 其他图标选项...
            })
          },
          polyline: {
            shapeOptions: {
              color: "#278BFB", // 设置绘制线条的颜色
              opacity: 0.8
            }
          }
        }
      });
      // 将绘制控件添加到地图上
      this.map.addControl(this.drawControl);

      // 地图加载完成后再执行操作
      map.whenReady(() => {
        //定位用户地理位置
        // this.getUserLocation();
        if (this.showType.length > 0) {
          //航点管理，新增和编辑可绘制点
          if (this.showType == "AirPoint") {
            if (this.airPoint[0] > 0 && this.airPoint[1] > 0) {
              this.resetPointBtn();
              this.drawMaker(this.airPoint);
            }
            // if (this.canDraw) {
            //   this.enableMarkerDrawing();
            // }
          } else {
            //航线管理，可选航点绘制航线，以及报告的航迹展示
            this.resetLineBtn();
            this.drawWay();
          }
        }
      });

      // 监听绘制事件
      let that = this;
      map.on("draw:created", function(event) {
        // 将绘制的图层添加到地图上
        var layer = event.layer;
        // 获取图层类型
        var layerType = event.layerType;
        drawnItems.addLayer(layer);
        that.drawnItems = drawnItems;

        if (layerType == "marker") {
          // 获取点的经纬度，回显表单数据
          var latlng = layer.getLatLng();
          let point = gcj02ToWgs84(latlng.lng, latlng.lat);
          that.$emit("update-marker", [
            point[0].toFixed(7),
            point[1].toFixed(7)
          ]);
        } else if (layerType == "polyline") {
          // let tooltip = document.getElementsByClassName(
          //   "leaflet-draw-tooltip"
          // )[0].children;
          // console.log("tooltip", tooltip);
          // if (tooltip.length > 1) {
          //   tooltip[2].innerHTML = "双击结束绘制";
          // } else {
          //   tooltip[0].innerHTML = "点击开始绘制航线";
          // }
          // tooltip.innerHTML = "双击结束绘制航线";
          // 获取航点的经纬度，清除表单数据
          var latlngs = layer.getLatLngs(); // 获取线上的所有顶点
          let points = [];
          latlngs.forEach(item => {
            let point = gcj02ToWgs84(item.lng, item.lat);
            points.push([point[0].toFixed(7), point[1].toFixed(7)]);
          });
          that.$emit("update-line", points);
          // 执行针对折线的操作
        }
      });
      map.on("draw:drawstart", function(e) {
        if (e.layerType === "polyline") {
          // // 获取 tooltip 元素并修改其内容
          // let tooltip = document.getElementsByClassName(
          //   "leaflet-draw-tooltip"
          // )[0].children;
          // console.log("tooltip1", tooltip);
          // if (tooltip.length > 1) {
          //   tooltip[2].innerHTML = "双击结束绘制";
          // } else {
          //   tooltip[0].innerHTML = "点击开始绘制航线";
          // }
        }
      });
      // 监听绘制过程中添加顶点的事件
      // map.on("draw:drawvertex", function(e) {
      //   let tooltip = document.getElementsByClassName("leaflet-draw-tooltip")[0]
      //     .children;
      //   console.log("tooltip2", tooltip);
      //   if (tooltip.length > 1) {
      //     tooltip[2].innerHTML = "双击结束绘制";
      //   } else {
      //     tooltip[0].innerHTML = "点击开始绘制航线";
      //   }
      //   console.log(tooltip[2].innerHTML);
      // });
    },
    //定位用户地理位置
    getUserLocation() {
      let _this = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            var lat = position.coords.latitude;
            var lon = position.coords.longitude;
            // 缩放级别 1: 整个世界
            // 缩放级别 5: 大洲
            // 缩放级别 10: 国家
            // 缩放级别 12: 大城市或州
            // 缩放级别 15: 城市或县
            // 缩放级别 17: 街道
            // 缩放级别 19: 建筑物
            let point = wgs84ToGcj02(lon, lat);
            _this.map.setView([point[1], point[0]], 10);
          },
          function(error) {
            // 错误回调

          }
        );
      } else {
        // 浏览器不支持Geolocation
        alert("Your browser doesn't support geolocation.");
      }
    },
    //选择航点
    choosePoint() {
      this.checkedPoint = true;

      if (this.markerPoint) {
        this.map.removeLayer(this.markerPoint);
      }

      this.$emit("update-marker", [null, null]);
      this.enableMarkerDrawing();
    },
    //取消航点
    cancelPoint() {
      this.checkedPoint = false;
      if (this.drawnItems) {
        this.drawnItems.clearLayers();
        this.map.addControl(this.drawControl);
      }

      this.$emit("update-marker", [null, null]);
    },
    //重置航点选择按钮
    resetPointBtn() {
      this.checkedPoint = false;
      if (this.markerPoint) {
        this.map.removeLayer(this.markerPoint);
      }
      if (this.drawnItems) {
        this.drawnItems.clearLayers();
        this.map.addControl(this.drawControl);
      }
    },
    //选择航线
    chooseLine() {
      this.checkedLine = true;
      if (this.positionLine) {
        this.map.removeLayer(this.positionLine);
      }
      this.$emit("choose-line", true);
      this.$emit("update-line", []);
      this.enablePolylineDrawing();
    },
    //取消航线
    cancelLine() {
      this.checkedLine = false;
      if (this.positionLine) {
        this.map.removeLayer(this.positionLine);
      }
      if (this.drawnItems) {
        this.drawnItems.clearLayers();
        this.map.addControl(this.drawControl);
      }
      this.$emit("choose-line", false);
      this.$emit("update-line", []);
    },
    //重置航线选择按钮
    resetLineBtn() {
      this.checkedLine = false;
      if (this.canDraw) {
        if (this.positionLine) {
          this.map.removeLayer(this.positionLine);
        }
        if (this.drawnItems) {
          this.drawnItems.clearLayers();
          this.map.addControl(this.drawControl);
        }
      }
    },
    //展示航点
    drawMaker(data) {
      let point = wgs84ToGcj02(data[0], data[1]);
      let point1 = [point[1], point[0]];
      this.addMarker(point1);
      this.map.setView(point1, 12);
    },
    //区分航道or航迹
    drawWay() {
      if (this.positionLine) {
        this.map.removeLayer(this.positionLine);
      }
      if (this.airpointList.length > 0) {
        let planepoints = [];
        this.airpointList.forEach(item => {
          let point = wgs84ToGcj02(item.longitude, item.latitude);
          planepoints.push([point[1], point[0]]);
        });
        if (this.showType == "AirPath") {
          this.addMarker(planepoints[planepoints.length - 1]);
        }
        let color =
          this.showType == "AirLine" ? "rgba(14, 29, 192,0.5)" : "green";
        let weight = this.showType == "AirLine" ? 10 : 5;
        this.planeWay(planepoints, color, weight);
      }
    },
    //画点
    addMarker(lastPoint) {
      if (this.markerPoint) {
        this.map.removeLayer(this.markerPoint);
      }
      //设置图标样式
      let icon = "";
      if (this.showType == "AirPath") {
        icon = "../../static/normalPoint.png";
      } else if (this.showType == "AirPoint") {
        icon = "../../static/normalPoint.png";
      }
      let myIcon = L.icon({
        iconUrl: icon,
        iconSize: [30, 30],
        className: "normal" // 添加我们定义的CSS类
      });
      let markerPoint = L.marker(lastPoint, {
        icon: myIcon
      }).addTo(this.map);

      this.markerPoint = markerPoint;
    },
    //绘制航道
    planeWay(wayPoints, wayColor, weight) {
      let planline = L.polyline(wayPoints, {
        smoothFactor: 1,
        color: wayColor, //航道颜色
        weight: weight //航道宽度
      }).addTo(this.map);
      this.map.setView(wayPoints[0], 12);
      this.positionLine = planline;
    },

    // 模拟用户点击折线绘制按钮
    enablePolylineDrawing() {
      var polygonButton = document.getElementsByClassName(
        "leaflet-draw-draw-polyline"
      )[0];
      if (polygonButton) {
        polygonButton.click();
        // let tooltip = document.getElementsByClassName("leaflet-draw-tooltip")[0]
        //   .children[0];
        // tooltip.innerHTML = "双击结束绘制航线";
      }
    },
    // 模拟用户点击点绘制按钮
    enableMarkerDrawing() {
      var polygonButton = document.getElementsByClassName(
        "leaflet-draw-draw-marker"
      )[0];
      if (polygonButton) {
        polygonButton.click();
        // let tooltip = document.getElementsByClassName("leaflet-draw-tooltip")[0]
        //   .children[0];
        // tooltip.innerHTML = "点击地图以放置标记";
      }
    }
  },
  watch: {
    //监听orderID变动则更新航道
    airpointList: {
      handler(newVal, oldVal) {
        this.drawWay();
      }
    },
    airPoint: {
      handler(newVal, oldVal) {
        this.resetPointBtn();
        if (newVal[0] > 0 && newVal[1] > 0) {
          this.drawMaker(newVal);
        }
      }
    },
    resetLineMap: {
      handler(newVal, oldVal) {
        this.resetLineBtn();
        // if (newVal[0] > 0 && newVal[1] > 0) {
        //   this.drawMaker(newVal);
        // }
      }
    }
  }
};
</script>

<style>
#overflow {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
}

#overflow .btn {
  width: 80px;
  height: 40px;
  text-align: center;
  /* background-image: url("../assets/img/2dmap/iconbac2.png");
  background-size: 100% 100%; */
  background-color: #010A12;
  border: 2px solid #00AEFF;
}

#overflow .btn:hover {
  cursor: pointer;
}

#overflow .cancelbtn {
}

#overflow .btn span {
  line-height: 40px;
  color: #fff;
}

.leaflet-draw-section {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/common/SecondMap.vue